export default __webpack_public_path__ + "static/media/StatusCompleted.23fbb77f.svg";